import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, Mascaras, formataCEP } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { LogradouroService } from '../logradouro/logradouro.service';

@Component({
  selector: 'ntc-logradouro-cep',
  templateUrl: './logradouro-cep.component.html',
  styleUrls: ['./logradouro-cep.component.css']
})
export class LogradouroCepComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridLogradouroCep = null;
  colunasGridLogradouroCep = null;
  logradouroCep = null;
  listaLogradouro = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private logradouroService: LogradouroService
  ) {

    this.logradouroCep = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/logradouro-cep/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/logradouro-cep/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/logradouro-cep/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/logradouro-cep/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridLogradouroCep = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'CEP',
        dataType: 'string',
        caption: 'CEP',
        validationRules: [{
          type: 'required',
          message: 'CEP é obrigatório.'
        }],
        editorOptions: { mask: Mascaras.Cep },
        customizeText: formataCEP
      }
    ];

    this.editOptionsGridLogradouroCep = {
      mode: GridConfig.gridMode, // form GridConfig.gridMode
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Logradouro CEP',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.logradouroService.getLogradouros().subscribe(logradouros => {
      this.listaLogradouro = logradouros;

      const selectLogradouro = {
        dataField: 'IdLogradouro',
        caption: 'Logradouro',
        lookup: {
            dataSource: this.listaLogradouro,
            displayExpr: 'NomeLogradouro',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Logradouro é obrigatória.'
        }]
      };

      this.colunasGridLogradouroCep.push(selectLogradouro);
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/logradouro-cep/logradouro-cep.component.ts